export const pageKeys = [
  { value: "lobby", label: "argen.pageKeys.lobby" },
  { value: "profile", label: "argen.pageKeys.profile" },
]

export const pagesNames = {
  lobby: "argen.pagesNames.lobby",
  profile: "argen.pagesNames.profile",
}
